export class PickupAssistant {
    public pickup_assistant_id: number;
    public pickup_assistant_name: string;
    public pickup_assistant_licence_number: string;
    public pickup_assistant_contact_number: string;
    public pickup_assistant_address_one: string;
    public pickup_assistant_city: string;
    public pickup_assistant_state: string;
    public pickup_assistant_zip_code: string;
    public pickup_assistant_vehicle_number: string;
    public student_id: number;
    public image_key: string;
    public photo_guid: string;
}